import CloseMenuIcon from './CloseMenuIcon'

export default CloseMenuIcon
